import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rx-row',
  templateUrl: './rx-row.component.html',
  styleUrls: ['./rx-row.component.scss'],
})
export class RxRowComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
